import { styled } from '@mui/material/styles';
import AdminCompanyTable from 'components/AdminCompanyTable';
import CompanySearchWidget from 'components/CompanySearchWidget';

const PREFIX = 'AdminHomePage';

const classes = {
  root: `${PREFIX}-root`,
  demo: `${PREFIX}-demo`
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',

  [`&.${classes.demo}`]: {
    backgroundColor: theme.palette.background.paper,
  },

}));

export default function AdminHomePage(): JSX.Element {
  return (
    <Root>
      <CompanySearchWidget
        ResultComponent={AdminCompanyTable}
      />
    </Root>
  );
}
